import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { project } from "../components/img";

function Project() {
  const [screen, setScreen] = useState();
  useEffect(() => {
    setScreen(window.innerWidth);
    const width = window.addEventListener("resize", () => {
      setScreen(window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", width);
    };
  }, [screen]);

  return (
    <Main>
      <div className="header">
        <p className="header-one">MY</p>
        <p className="header-two">PROJECTS</p>
      </div>
      <div className="project-container">
        <h1>this page is under construction</h1>
        {
          // project.map((items, i) => {
          // const { img, title, client, date, projectSummary } = items;
          // return (
          //   <div key={i} className="project">
          //     <div key={img} className="img-container">
          //       <img className="img" src={img} alt="" />
          //       <div className="project-title">
          //         <p className="title">{title}</p>
          //         <p className="date">{date}</p>
          //       </div>
          //     </div>
          //     <article className="project-summary">
          //       <p className="client">Client: {client}</p>
          //       <p className="summary-header">project summary</p>
          //       <div className="project-text">
          //         <p className="p1">{projectSummary}</p>
          //       </div>
          //     </article>
          //   </div>
          // );
          // })
        }
      </div>
    </Main>
  );
}
export default Project;

const Main = styled.div`
  background-color: ${(props) => props.theme.colors.bgcolor};
  /* height: calc(100vh - 170px); */
  height: calc(100vh - 170px);
  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    .header-one {
      font-size: 35px;
      font-weight: 800;
      letter-spacing: 2px;
      color: ${(props) => props.theme.colors.primarycolor};
    }
    .header-two {
      padding: 0 3px;
      font-size: 35px;
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 800;
      letter-spacing: 3px;
      color: ${(props) => props.theme.colors.primarycolor};
      background-color: ${(props) => props.theme.colors.border};
    }
  }
  .project-container {
    display: flex;
    justify-content: center;
    color: ${(props) => props.theme.colors.fontdarken};
    padding: 5% 0 0 0;
    text-transform: capitalize;
  }
`;
